'use client'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { ConsentGroup, useIsConsentGroupEnabled } from '@marketplace-web/consent/consent-feature'

import RoktAdvertisement from '../RoktAdvertisement'
import VanOfferAdvertisement from '../VanOfferAdvertisement'
import VanMultiOfferAdvertisement from '../VanMultiOfferAdvertisement'

const OfferAdvertisement = () => {
  const isOfferAdvertisementEnabled = useFeatureSwitch('web_offer_advertisement')
  const isMultiOfferEnabled = useFeatureSwitch('web_multi_offer')

  const hasConsentedTargeting = useIsConsentGroupEnabled(ConsentGroup.Targeting)
  const hasConsentedPersonalisedAds = useIsConsentGroupEnabled(ConsentGroup.PersonalisedAds)

  const shouldUserSeeAds = useAbTest('sqp_ads')?.variant === 'on'

  const isRoktScriptEnabled = useFeatureSwitch('web_ads_rokt_script')
  const hasConsentedRokt = useIsConsentGroupEnabled(ConsentGroup.RoktAdvertising)

  const shouldShowRokt =
    isRoktScriptEnabled &&
    shouldUserSeeAds &&
    hasConsentedRokt &&
    hasConsentedTargeting &&
    hasConsentedPersonalisedAds

  const multiOffersTest = useAbTest('multi_offers')
  useTrackAbTest(multiOffersTest, isMultiOfferEnabled)

  const shouldShowMultiOffers = isMultiOfferEnabled && multiOffersTest?.variant === 'on'

  if (!isOfferAdvertisementEnabled) return <RoktAdvertisement />

  if (shouldShowRokt) return <RoktAdvertisement />

  return shouldShowMultiOffers ? <VanMultiOfferAdvertisement /> : <VanOfferAdvertisement />
}

export default OfferAdvertisement
